import { UserAnalysisCancelResponseSchema, UserAnalysisHistoryResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type UserAnalysisCancelResponseInput = z.input<typeof UserAnalysisCancelResponseSchema>;
export type UserAnalysisCancelResponseOutput = z.output<typeof UserAnalysisCancelResponseSchema>;

export function serializeUserAnalysisCancelResponse(
  payload: UserAnalysisCancelResponseInput
): UserAnalysisCancelResponseOutput {
  return UserAnalysisCancelResponseSchema.parse(payload);
}

export type UserAnalysisHistoryResponseInput = z.input<typeof UserAnalysisHistoryResponseSchema>;
export type UserAnalysisHistoryResponseOutput = z.output<typeof UserAnalysisHistoryResponseSchema>;

export function serializeUserAnalysisHistoryResponse(
  payload: UserAnalysisHistoryResponseInput
): UserAnalysisHistoryResponseOutput {
  return UserAnalysisHistoryResponseSchema.parse(payload);
}
